import React from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import SharedLensPowerCalculator from "./SharedLensPowerCalculator";
const TITLE =
  "حاسبة قوة عدسة العين - تعلم كيفية حساب عدسة العين وقوتها البصرية";
const DESCRIPTION =
  "حاسبة قوة العدسة الإلكترونية: احسب قوة العدسات الطبية (بالديوبتر) بدقة فائقة! أدخل معامل انكسار العدسة ونصف قطر التكور لمعرفة القوة البصرية - أداة أساسية لأطباء العيون وفنيي النظارات الطبية.";
const KEYWORDS = "حساب عدسة العين, حساب القوة البصيرة";
const OG_URL = "https://do-calculate.com/calculator/ar/lenspower";
function Calculator() {
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  قوة العدسة البصرية تعبر عن قدرتها على تجميع الأشعة نحو المركز
                  البصري الرئيسي. يُمثل رمز قوة العدسة بحرف "C". تتناسب قوة
                  العدسة عكسيًا مع البعد البؤري، مما يعني أنه كلما زاد البعد
                  البؤري، قلت قوة العدسة، والعكس صحيح.
                  <br />
                  يمكن حساب قوة العدسة باستخدام المعادلة C=1/F، حيث يُمثل F
                  البعد البؤري. تكون قيمة C إيجابية في العدسات المحدبة، بينما
                  تكون سالبة في العدسات المقعرة."
                  <br />
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <SharedLensPowerCalculator />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default Calculator;
